module.exports = __webpack_public_path__ + "static/media/stockhausen_nowald_10.eb8cf579.jpeg";